import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Message } from '../../../../../../../components'
import { TextInput } from '../../../../../../../components/shared'
import { THEMES, MAX_PURCHASING_POWER_LENGTH } from '../../../../../../../utils'

/**
 * Info Modal
 * @param onClose
 * @return {*}
 * @constructor
 */
const InfoModal = ({ onClose }) => {
  return (
    <Message
      visible
      type='info'
      title='Purchasing Power'
      message={'<p>Proprietary calculation to determine the likely potential buying power of a given institution/fund in a given security returned as a position value. Purchasing power calculation inputs include such things as: AUMs, Sector/Industry Ownership, Market Cap Distribution, and Average Position Size.</p>'}
      useHtml
      onClose={onClose}
      renderExitButton
      buttons={[{
        ui: 'citrus',
        label: 'Ok',
        onClick: onClose
      }]}
    />
  )
}
/**
 * Purchasing Power Filter
 */
class PurchasingPower extends PureComponent {
  /**
   * On Min Value Change
   * @param event
   */
  onMinChange (event) {
    const { value } = this.props
    if(event.currentTarget.value.length > MAX_PURCHASING_POWER_LENGTH){
      event.currentTarget.value =  event.currentTarget.value.slice(0,MAX_PURCHASING_POWER_LENGTH )
    }
    const minValue = event.currentTarget.value
    const maxValue = value && value[1]

    this.onChange([minValue, maxValue])
  };

  /**
   * On Max Value Change
   * @param event
   */
  onMaxChange (event) {
    if(event.currentTarget.value.length > MAX_PURCHASING_POWER_LENGTH){
      event.currentTarget.value =  event.currentTarget.value.slice(0,MAX_PURCHASING_POWER_LENGTH )
    }
    const { value } = this.props
    const maxValue = event.currentTarget.value
    const minValue = value && value[0]

    this.onChange([minValue, maxValue])
  };

  /**
   * Wrapper for onchange with validation on fly
   * @param value
   */
  onChange = (value) => {
    const { onChange, onValidate } = this.props
    const ret = this.validate(false, value)
    onValidate && onValidate(ret)
    onChange(value)
  }

  /**
   * Restrict special characters
   * @param event
   */
  onKeyDown (event) {
    const restrictedKeys = [109, 189, 187]
    const keyCode = event.which || event.keyCode

    if (restrictedKeys.includes(keyCode)) {
      event.preventDefault()
    }
  };

  /**
   * Show Info Modal
   */
  onInfoClick () {
    const { openModal } = this.props
    openModal({
      component: InfoModal
    })
  };

  /**
   * Validation
   * @return {boolean}
   */
  validate (throwError = true, formValue = null) {
    const { onError } = this.props
    const value = formValue || this.props.value
    const minValue = parseInt(value[0], 0)
    const maxValue = parseInt(value[1], 0)

    if (minValue < 0) {
      throwError && onError('Min value must be 0 or above')
      return false
    }

    if (maxValue < 0) {
      throwError && onError('Max value must be 0 or above')
      return false
    }

    if (minValue > maxValue && !isNaN(maxValue)) {
      throwError && onError('Min value cannot be greater than the max')
      return false
    }

    onError(null)
    return true
  };

  /**
   * Render
   * @return {*}
   */
  render () {
    const { value, error } = this.props
    const min = (value && value[0]) || ''
    const max = (value && value[1]) || ''

    return (
      <div className='field field--text field--coupled'>
        <label className='field_label'>
          Purchasing Power
          <span className='button--info button--soft-grey' onClick={this.onInfoClick.bind(this)}/>
        </label>
        <div className='field_set'>
          <TextInput
            type='number'
            min={0}
            value={min}
            error={error}
            placeholder='Min'
            autoComplete='false'
            onChange={this.onMinChange.bind(this)}
            onKeyDown={this.onKeyDown.bind(this)}
            onBlur={this.validate.bind(this)}
            theme={THEMES.WHITE}
            onlyInteger
          />
          <TextInput
            type='number'
            min={0}
            value={max}
            error={error}
            placeholder='Max'
            autoComplete='false'
            onChange={this.onMaxChange.bind(this)}
            onKeyDown={this.onKeyDown.bind(this)}
            onBlur={this.validate.bind(this)}
            theme={THEMES.WHITE}
            onlyInteger
          />
        </div>
        {error && (
          <div className='field_error'>
            {error}
          </div>
        )}
      </div>
    )
  }
}

PurchasingPower.propTypes = {
  value: PropTypes.array.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValidate: PropTypes.func,
  openModal: PropTypes.func.isRequired
}

export default PurchasingPower
